import React from 'react'
import '../styles/table.css'

function Table({ playersData, updateRowRequest, updateTableDataInParent, paymentValue, isPlus }) {
  const RAKE = 0.1;
  const MAX_RAKE = 150;
  const totals = getTotals(playersData.players);
  if (!playersData || !playersData.players) {
    return <div>Loading...</div>; // You can replace this with a loading indicator or any other message
  }
  function calculateProfit(buyIn, outcome) {
    return parseInt(outcome - buyIn - calculateRake(buyIn, outcome));
  }
  function calculateRake(buyIn, outcome) {
    return outcome - buyIn > 0 ? Math.min(parseInt((outcome - buyIn) * RAKE), MAX_RAKE) : 0;
  }

  function getTotals(playersData) {
    if (!playersData) return { buyInTotal: 0, rakeTotal: 0, outcomeTotal: 0 }
    return playersData.reduce(
      (accumulator, player) => {
        accumulator.buyInTotal += player.buyinAmount;
        accumulator.outcomeTotal += player.playerOutcome;
        accumulator.rakeTotal += calculateRake(player.buyinAmount, player.playerOutcome)
        return accumulator;
      },
      { buyInTotal: 0, rakeTotal: 0, outcomeTotal: 0 }
    );
  }

  function handleRowClick(playerId, columnName, amount) {
    if (isNaN(amount) || amount === 0) return;
    const updatedPlayers = playersData.players.map(player => {
      if (player.playerId === playerId) {
        amount = amount * (isPlus ? 1 : -1)
        const updatedPlayer = {
          ...player,
          [columnName]: player[columnName] + amount,
          playerProfit: calculateProfit(columnName === 'buyinAmount' ? player[columnName] + amount : player.buyinAmount,
            columnName === 'playerOutcome' ? player[columnName] + amount : player.playerOutcome),
          playerRake: calculateRake(columnName === 'buyinAmount' ? player[columnName] + amount : player.buyinAmount,
            columnName === 'playerOutcome' ? player[columnName] + amount : player.playerOutcome),
        }
        updateRowRequest(playersData.gameID, updatedPlayer, amount, columnName === 'buyinAmount')
        return updatedPlayer
      } else {
        return player;
      }
    })
    updateTableDataInParent(updatedPlayers)
    console.log(updatedPlayers);
  }

  return (
    <>
      <table className="table">
        <thead>
          <tr>
            <th>שם</th>
            <th>פריטה</th>
            <th>תשלום</th>
            <th>סיום</th>
            <th>רווח</th>
            <th>גנייה</th>
          </tr>
        </thead>
        <tbody>
          {playersData.players.map(player => (
            <tr key={player.playerId}>
              <td className='unavailableRows'>{player.playerName}</td>
              <td className={isPlus ? `addPayment` : `removePayment`} onClick={() => handleRowClick(player.playerId, "buyinAmount", paymentValue)}>{player.buyinAmount}</td>
              <td className={isPlus ? `addPayment` : `removePayment`} onClick={() => handleRowClick(player.playerId, "playerPayment", paymentValue)}>{player.playerPayment}</td>
              <td className={isPlus ? `addPayment` : `removePayment`} onClick={() => handleRowClick(player.playerId, "playerOutcome", paymentValue)}>{player.playerOutcome}</td>
              {/* <td className='unavailableRows'>{calculateProfit(player.buyinAmount, player.playerOutcome)}</td>
            <td className='unavailableRows'>{calculateRake(player.buyinAmount, player.playerOutcome)}</td> */}
              <td className='unavailableRows'>{player.playerProfit}</td>
              <td className='unavailableRows'>{player.playerRake}</td>
            </tr>
          ))}
          <tr key={"Total"}>
            <td className='unavailableRows'></td>
            <td className='unavailableRows'>{totals.buyInTotal}</td>
            <td className='unavailableRows'></td>
            <td className='unavailableRows'>{totals.outcomeTotal}</td>
            <td className='unavailableRows'></td>
            <td className='unavailableRows'>{totals.rakeTotal}</td>
          </tr>
        </tbody>
      </table>

    </>
  )
}

export default Table